import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StateService } from "../../../../state/state.service";
import { SsoAccountState } from "../models/sso-account-state.model";
import { SsoAccountCheckoutState, SsoAccountData } from "../models/sso-account.model";

const initialState: SsoAccountState = null;

@Injectable({
  providedIn: "root",
})
export class SsoAccountStateService extends StateService<SsoAccountState> {
  constructor() {
    super(initialState);
  }

  getCurrentSsoAccount$(): Observable<SsoAccountData> {
    return this.select((state: SsoAccountState) => state?.currentSsoAccount);
  }
  
  getSsoAccountCheckoutState$(): Observable<SsoAccountCheckoutState> {
    return this.select((state: SsoAccountState) => state?.ssoAccountCheckoutState);
  }

  setCurrentSsoAccount(data: SsoAccountData): void {
    const newState = {
      ...this.state,
      currentSsoAccount: data,
    };
    this.setState(newState);
  }

  setSsoAccountCheckoutState(data: SsoAccountCheckoutState): void {
    const newState = {
      ...this.state,
      ssoAccountCheckoutState: data,
    };
    this.setState(newState);
  }

  isCurrentSsoAccountStateLoaded(): boolean {
    return !!this.state?.currentSsoAccount;
  }

  isSsoAccountCheckoutStateLoaded(): boolean {
    return !!this.state?.ssoAccountCheckoutState;
  }

  clearState(): void {
    this.initState(initialState);
  }
}
